import {MaterialReactTable, useMaterialReactTable} from "material-react-table";
import {copyToClipboard, defaultDataGridProperties} from "../utils/DataGridUtils";
import {useMemo, useState} from "react";
import Stack from "@mui/material/Stack";
import DataGridHeader from "../DataGridHeader";
import Divider from "@mui/material/Divider"
import ListItemIcon from "@mui/material/ListItemIcon";
import MenuItem from "@mui/material/MenuItem";
import ContentCopy from "@mui/icons-material/ContentCopy"
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

const formatSalary = (value) => {
    if (value) {
        const zeroPlaces = +Number(value.toFixed(0));
        return `£${zeroPlaces.toLocaleString()}`;
    }

    return '';
};

const LevelsDataGrid = ({data, columnLabels}) => {
    const [copyAlert, setCopyAlert] = useState(false);

    const columns = useMemo(() => {
            const copyItem = (accessor) => {
                return ({internalColumnMenuItems}) => [
                    ...internalColumnMenuItems,
                    <Divider key={`${accessor}CopyDivider`}/>,
                    <MenuItem key={`${accessor}Copy`} onClick={() => copyRow(accessor)}><ListItemIcon><ContentCopy fontSize="small"/></ListItemIcon>Copy Column Data</MenuItem>
                ];
            };

            const copyRow = (accessor) => {
                let output = "";
                if (accessor === "label") {
                    output += columnLabels["firstColumn"] + "\n";
                } else {
                    output += columnLabels[accessor] + "\n";
                }

                output += data.rows.map((row) => row[accessor]).join("\n");

                copyToClipboard(output, setCopyAlert);
            };

            return [
                {
                    accessorKey: 'label',
                    header: columnLabels.firstColumn,
                    size: 162,
                    renderColumnActionsMenuItems: copyItem("label"),
                },
                {
                    accessorKey: "salaryCount",
                    header: columnLabels.salaryCount,
                    muiTableBodyCellProps: {
                        align: 'right',
                    },
                    size: 136,
                    renderColumnActionsMenuItems: copyItem("salaryCount"),
                },
                {
                    accessorKey: "companyCount",
                    header: columnLabels.companyCount,
                    muiTableBodyCellProps: {
                        align: 'right',
                    },
                    size: 158,
                    renderColumnActionsMenuItems: copyItem("companyCount"),
                },
                {
                    accessorKey: "lowerQuartile",
                    header: columnLabels.lowerQuartile,
                    Cell: ({renderedCellValue}) => (<>{formatSalary(renderedCellValue)}</>),
                    muiTableBodyCellProps: {
                        align: 'right',
                    },
                    size: 148,
                    renderColumnActionsMenuItems: copyItem("lowerQuartile"),
                },
                {
                    accessorKey: "medianQuartile",
                    header: columnLabels.medianQuartile,
                    Cell: ({renderedCellValue}) => (<>{formatSalary(renderedCellValue)}</>),
                    muiTableBodyCellProps: {
                        align: 'right',
                    },
                    size: 97,
                    renderColumnActionsMenuItems: copyItem("medianQuartile"),
                },
                {
                    accessorKey: "upperQuartile",
                    header: columnLabels.upperQuartile,
                    Cell: ({renderedCellValue}) => (<>{formatSalary(renderedCellValue)}</>),
                    muiTableBodyCellProps: {
                        align: 'right',
                    },
                    size: 147,
                    renderColumnActionsMenuItems: copyItem("upperQuartile"),
                },
                {
                    accessorKey: "average",
                    header: columnLabels.average,
                    Cell: ({renderedCellValue}) => (<>{formatSalary(renderedCellValue)}</>),
                    muiTableBodyCellProps: {
                        align: 'right',
                    },
                    size: 104,
                    renderColumnActionsMenuItems: copyItem("average"),
                },
            ];
        },
        [columnLabels, data]);

    const table = useMaterialReactTable({
        ...defaultDataGridProperties,
        columns: columns,
        data: data.rows,
    });

    const handleCloseSnackBar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setCopyAlert(false);
    };

    return (
        <Stack id="levels-data" name="levels-data">
            <DataGridHeader table={table}/>
            <MaterialReactTable table={table}/>
            <Snackbar
                open={copyAlert}
                anchorOrigin={{"vertical": "bottom", "horizontal": "right"}}
                autoHideDuration={6000}
                onClose={handleCloseSnackBar}
            >
                <Alert severity="success">Column data copied to clipboard</Alert>
            </Snackbar>
        </Stack>
    );
};

export default LevelsDataGrid;
